<section class="top-page-margin profile-page">
  <h1 class="sr-only">{{ pageLabels?.['viewEntEmpty.tag_name'] }}</h1>
  <div class="container">
    <!--Club-UniversalCTA  Header Naviagte to Dahboard Page-->
    <div class="dashboard-welcome-header">
      <gds-spacer classes="spacer-50"></gds-spacer>
      <div class="dashboard-content-data">
        <div class="dashboard-data">
          <div class="club-universal-btn">
            <gds-utility-action
              [data]="{
                icon: {
                  iconName: 'left-arrow-v2',
                },
                label: pageLabels?.['viewEntEmpty.backCTA'],
                type: 'left-arrow-v2',
                disabled: false,
              }"
              contrast="true"
              (click)="goToPage(pageLabels?.['page.dashboard'])"
            ></gds-utility-action>
          </div>
        </div>
      </div>
    </div>
    <div class="content-heading">
      <gds-spacer classes="spacer-70"></gds-spacer>

      <!--Entitlement heading -->
      <gds-heading
        [data]="{
          heading: pageLabels?.['viewEntEmpty.heading'],
        }"
        class="A2-W5"
      >
      </gds-heading>
      <gds-spacer classes="spacer-50"></gds-spacer>

      <!--Entitlement description -->
      <gds-heading
        class="A3-W6"
        classes="heading-7"
        [data]="{
          heading: pageLabels?.['viewEntPopulated.desc'],
        }"
      ></gds-heading>
      <gds-spacer classes="spacer-50"></gds-spacer>

      <!--Tabs for Entitlement -->
      @if (tabData?.length > 0) {
        <gds-tabs
          [data]="{
            tabContents: tabData,
          }"
          (tabChanged)="updateTab($event, tabData)"
          contrast="true"
        >
        </gds-tabs>
      }
      @if (isShowEntitlement) {
        <!--Qr Code Image for Entitlement -->
        <div class="grid">
          <div class="tickets-card">
            <gds-spacer class="desktop-only" classes="spacer-50"></gds-spacer>
            @for (data of guestTicketsArray; track data; let last = $last) {
              <div class="guest-ticket">
                <div
                  class="col-md-3 contentTab"
                  tabindex="0"
                  (click)="getTickets(data)"
                  (keydown.enter)="getTickets(data)"
                  (keyup.Space)="getTickets(data)"
                >
                  <div class="align-left">
                    <div class="image-sec">
                      <div
                        [attr.aria-label]="getAriaLabelDate(data)"
                        role="text"
                      >
                        <gds-poi-feature
                          aria-hidden="true"
                          [data]="{
                            icon: 'tickets2',
                            heading:
                              data?.tridionContentProductName ||
                              data?.commerceProductName ||
                              data.name,
                            description: getDescription(data),
                          }"
                        >
                        </gds-poi-feature>
                      </div>
                    </div>
                    <!--Tickets arrow redirect to Tickets-details page-->
                    <i
                      _ngcontent-wgy-c178=""
                      aria-hidden=""
                      class="icon icon-arrow-right"
                    ></i>
                  </div>
                </div>
                @if (!last) {
                  <gds-spacer classes="spacer-70"></gds-spacer>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (isEmptyEntitlement) {
        <!--Empty Entititlement ticket description-->
        <gds-spacer classes="spacer-30"></gds-spacer>
        <div class="ticket-description">
          <gds-heading
            [data]="{
              heading: pageLabels?.['viewEntEmpty.noticketsDesc'],
            }"
            class="hippogriff A6-W3"
          >
          </gds-heading>
        </div>
        <gds-spacer classes="spacer-50"></gds-spacer>
      }
      <gds-spacer classes="spacer-80"></gds-spacer>
      <gds-right-hand-rail-divider></gds-right-hand-rail-divider>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <div
        class="align-left contentTab"
        tabindex="0"
        role="link"
        (click)="redirectToWTS()"
        (keydown.enter)="redirectToWTS()"
        (keyup.Space)="redirectToWTS()"
      >
        <div class="icon-container">
          <gds-svg
            icon-name="shopping2"
            fill-color="#222"
            width="32"
            height="32"
          ></gds-svg>

          <!--Purchase Ticket Heading-->
          <gds-spacer classes="vertical-spacer-20"></gds-spacer>
          <gds-heading
            class="B1-W4 cursor-focus"
            [data]="{
              heading: pageLabels?.['viewEntEmpty.buyTicketsCTA'],
            }"
          ></gds-heading>
        </div>
        <!--Details text and right arrow icon-->
        <div class="details-click">
          <i aria-hidden="" class="icon icon-arrow-right"></i>
        </div>
      </div>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <gds-right-hand-rail-divider></gds-right-hand-rail-divider>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <div
        class="align-left contentTab"
        tabindex="0"
        (click)="redirectTolinkticket()"
        (keydown.enter)="redirectTolinkticket()"
        (keyup.Space)="redirectTolinkticket()"
        role="link"
      >
        <div class="icon-container">
          <gds-svg
            icon-name="barcode"
            fill-color="#222"
            width="32"
            height="32"
          ></gds-svg>
          <gds-spacer classes="vertical-spacer-20"></gds-spacer>

          <!--Register Ticket Heading-->
          <gds-heading
            class="B1-W4 cursor-focus"
            [data]="{
              heading: pageLabels?.['viewEntEmpty.linkTicketsCTA'],
            }"
          ></gds-heading>
        </div>

        <!--Details text and right arrow icon-->
        <div class="details-click">
          <i aria-hidden="" class="icon icon-arrow-right"></i>
        </div>
      </div>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <gds-right-hand-rail-divider></gds-right-hand-rail-divider>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <div
        class="align-left contentTab"
        tabindex="0"
        role="link"
        [class.disabled]="this.expiredTicketsArray?.length <= 0"
        (click)="this.expiredTicketsArray?.length > 0 && viewPastTickets()"
        (keydown.enter)="
          this.expiredTicketsArray?.length > 0 && viewPastTickets()
        "
        (keyup.Space)="
          this.expiredTicketsArray?.length > 0 && viewPastTickets()
        "
      >
        <div
          class="icon-container"
          [class.disabled]="this.expiredTicketsArray?.length === 0"
        >
          <gds-svg
            icon-name="tickets-empty"
            fill-color="#222"
            width="32"
            height="32"
          ></gds-svg>
          <gds-spacer classes="vertical-spacer-20"></gds-spacer>

          <!--Past Ticket Heading-->
          <gds-heading
            class="B1-W4 cursor-focus"
            [data]="{
              heading: pageLabels?.['viewEntEmpty.seePastTickets'],
            }"
          ></gds-heading>
        </div>
        <!--Details text and right arrow icon-->
        <div
          [class.disabled]="this.expiredTicketsArray?.length === 0"
          class="details-click"
        >
          <i aria-hidden="" class="icon icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</section>
